import React from 'react';
import { Box } from '@mui/material';
import ComingSoon from '../../Components/ComingSoon';

const Training: React.FC = () => {
  return (
    <Box>
      <ComingSoon
        title="Training"
        subtitle="Annual Reports Training Materials"
        description="Access training videos, tutorials, and learning materials to help you navigate the annual reports process successfully."
      />
    </Box>
  );
};

export default Training;
